import { render } from "./FooterWidget.vue?vue&type=template&id=1305d63b"
import script from "./FooterWidget.vue?vue&type=script&lang=js"
export * from "./FooterWidget.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__